<template>
  <div class="s-guide__wrapper">
    <div class="container">
      <div class="s-guide__tabs">
        <div class="e-tabs">
          <ul>
            <li
              v-for="tab in tabs"
              :key="tab.id"
              class="e-tabs__tab"
              :class="{ 'e-tabs__tab--active': currentTabId === tab.id }"
              @click="selectTab(tab.id)">
              <span>{{ tab.label }}</span>
            </li>
          </ul>
        </div>
      </div>

      <div class="s-guide__content">
        <div class="s-guide__card">
          <div class="row">
            <div class="s-guide__card-left col-lg-6">
              <h3 class="s-guide__card-title">{{ currentContent.title }}</h3>
              <div
                class="s-guide__card-text"
                v-html="currentContent.text"></div>
              <div
                v-if="desktop && currentContent.cta && currentContent.cta.label"
                class="s-guide__card-cta">
                <a
                  :href="currentContent.cta.url"
                  :target="currentContent.cta.target || '_self'"
                  :title="currentContent.cta.label">
                  <span>{{ currentContent.cta.label }}</span>
                </a>
              </div>
            </div>
            <div class="s-guide__card-right col-lg-6">
              <div class="s-guide__card-img">
                <img
                  v-if="currentContent.img && currentContent.img.url"
                  :src="currentContent.img.url"
                  :alt="currentContent.img.alt"
                  :width="currentContent.img.width"
                  :height="currentContent.img.height" />
              </div>
            </div>
            <div
              v-if="!desktop && currentContent.cta && currentContent.cta.label"
              class="s-guide__card-cta">
              <a
                :href="currentContent.cta.url"
                :target="currentContent.cta.target || '_self'"
                :title="currentContent.cta.label">
                <span>{{ currentContent.cta.label }}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'
import { getData } from '../../lib/lib'
import useViewport from '../../features/viewport'

const { tabs } = getData('guideData')

// reactive data
const { desktop } = useViewport()
const currentTabId = ref('')

// hooks
onMounted(() => {
  if (tabs && tabs.length > 0) {
    currentTabId.value = tabs[0].id
  }
})

// computed
const currentContent = computed(() => {
  const tab = tabs.find((t) => t.id === currentTabId.value)
  return tab && tab.content
    ? tab.content
    : { title: '', text: '', cta: {}, img: {} }
})

// methods
const selectTab = (tabId) => {
  currentTabId.value = tabId
}
</script>
